<template>
  <div>
  <vx-card>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vs-table
        :max-items="descriptionItems[1]"
        pagination
        :description="false"
        :data="entities"
        search
        @selected="handleSelected"
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header">
          <div class="list-heading">
            {{ $t("setup.label.ChargeCode") }}
          </div>

          <div class="mr-2 mb-1 order-1">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              @click="$router.push({ name: 'Create Charge Code' })"
              size="small"
              >{{ $t("setup.label.CreateChargeCode") }}</vs-button
            >
          </div>
        </template>
        <template slot="thead">
          <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>
          <vs-th>{{ $t("setup.label.ChargeDescription") }}</vs-th>
          <vs-th>{{ $t("setup.label.ChargeType") }}</vs-th>
          <vs-th>{{ $t("setup.label.ChargeDuration") }}</vs-th>
          <vs-th>{{ $t("setup.label.DurationType") }}</vs-th>
          <vs-th>{{ $t("setup.label.TaxInclusive") }}</vs-th>
          <vs-th>{{ $t("setup.label.BillFrequencyCode") }}</vs-th>

          <vs-th clas="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" :data="entity" v-for="(entity, index) in data">
            <vs-td :data="entity.chargeCode">{{ entity.chargeCode }}</vs-td>
            <vs-td :data="entity.chargeDescription">{{
              entity.chargeDescription
            }}</vs-td>
            <vs-td :data="entity.chargeType">{{ entity.chargeType }}</vs-td>
            <vs-td :data="entity.chargeDuration">{{
              entity.chargeDuration
            }}</vs-td>
            <vs-td :data="entity.durationType">{{ entity.durationType }}</vs-td>
            <vs-td :data="entity.taxInclusive">{{ entity.taxInclusive }}</vs-td>
            <vs-td :data="entity.billFrequencyCode">{{
              entity.billFrequencyCode
            }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <feather-icon
                  icon="EyeIcon"
                  :title="$t('setup.label.View')"
                  svgClasses="w-5 h-5 stroke-current cursor text-primary"
                  @click.stop="handleSelected(entity)"
                  class="icon_row"
                />
                <feather-icon
                  icon="EditIcon"
                  :title="$t('setup.label.Edit')"
                  class="icon-warning icon_row"
                  svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                  @click.stop="editData(entity.id)"
                />
                <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteChargePopup = true;
                      delId = entity.id;
                    "
                    class="icon_row"
                  />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </vx-card>
  <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.DeleteChargeCode')"
          :active.sync="deleteChargePopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteChargePopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >
            <span class="p-2">
              <vs-button @click="removeItem(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      treeview: false,
      descriptionItems: [5, 10, 15],
      deleteChargePopup: false,
    };
  },
  components: { "v-select": vSelect, AtomSpinner },
  computed: {
    ...mapGetters({ entities: "chargecode/getEntityList" }),
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    handleSelected(item) {
      this.$router.push({
        name: "View Charge Code",
        params: { id: item.id, chargeCode: item.chargeCode },
      });
    },
    editData(id) {
      this.$router.push({ name: "Edit Charge Code", params: { id } });
    },

    getEntityList() {
      this.loading = true;
      try {
        this.$store.dispatch("chargecode/setEntities");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async removeItem(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("chargecode/deleteChargeCodeAction", id);
        this.deleteChargePopup = false;
        this.getEntityList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getEntityList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
